__turbopack_context__.v({
  "Content": "AccordionItem-module-scss-module__rzeBZa__Content",
  "Details": "AccordionItem-module-scss-module__rzeBZa__Details",
  "Icon": "AccordionItem-module-scss-module__rzeBZa__Icon",
  "IsTimeline": "AccordionItem-module-scss-module__rzeBZa__IsTimeline",
  "Title": "AccordionItem-module-scss-module__rzeBZa__Title",
  "TitleContainer": "AccordionItem-module-scss-module__rzeBZa__TitleContainer",
  "TitleIconContainer": "AccordionItem-module-scss-module__rzeBZa__TitleIconContainer",
  "Toggle": "AccordionItem-module-scss-module__rzeBZa__Toggle",
});
